import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryQuestionAspect extends ConditionRegistryCategory {
    label = 'Aspect (Hover,...)';
    constructor(parent) {
        super(parent);
        super.init();
    }
    combinedHoveringAnswering = () => new ConditionRegistryItem({
        /*   label: 'Aspekt hover & question answering', */
        eval: ({ aspect, question }) => {
            if (!question)
                return false;
            if (!question.answeringState.isInAnsweringState)
                return false;
            return aspect.aspectInteract.isAspectHovering;
        }
    });
}
